
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface ActivitySectionProps {
  title: string;
  children: React.ReactNode;
}

export function ActivitySection({ title, children }: ActivitySectionProps) {
  return (
    <Card className="mt-8 rounded-sm bg-card">
      <CardHeader>
        <CardTitle className="text-foreground">{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {children}
      </CardContent>
    </Card>
  );
}
